import Group from './group';
import InternalRadio from './radio';
import Bordered from './radioBordered';
import Button from './radioButton';

export type {
  RadioChangeEvent,
  RadioChangeEventTarget,
  RadioGroupButtonStyle,
  RadioGroupContextProps,
  RadioGroupOptionType,
  RadioGroupProps,
  RadioProps,
  RadioRef,
} from './interface';
export { Button, Group };

type CompoundedComponent = typeof InternalRadio & {
  Group: typeof Group;
  Button: typeof Button;
  Bordered: typeof Bordered;
  /** @internal */
  __ANT_RADIO: boolean;
};

const Radio = InternalRadio as CompoundedComponent;
Radio.Button = Button;
Radio.Bordered = Bordered;
Radio.Group = Group;
Radio.__ANT_RADIO = true;
export default Radio;
